import { render, staticRenderFns } from "./Respite-care.vue?vue&type=template&id=71902d5a"
import script from "./Respite-care.vue?vue&type=script&lang=js"
export * from "./Respite-care.vue?vue&type=script&lang=js"
import style0 from "./Respite-care.vue?vue&type=style&index=0&id=71902d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports